import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    location: str
*/
async function handlePostDeliveryLocations(location, fetch) {
    
    const response = await fetch.post(`${apiBaseURL}/api/DeliveryLocation`, location);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';

    console.log('handlePostDeliveryLocations location', location);
    console.log('handlePostDeliveryLocations response', response);

    return {
        response,
        isDataGood
    };
}
export default handlePostDeliveryLocations;